import type { TileConfig } from '../config/schema';
import Tile from './Tile';
import TileSkeleton from './TileSkeleton';

interface TileGridProps {
  tiles: TileConfig[];
}

interface TileGridSkeletonProps {
  count?: number;
}

export function TileGridSkeleton({ count = 6 }: TileGridSkeletonProps) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: 'var(--sp-5)',
    }}>
      {Array.from({ length: count }, (_, i) => <TileSkeleton key={i} />)}
    </div>
  );
}

export default function TileGrid({ tiles }: TileGridProps) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: 'var(--sp-5)',
    }}>
      {tiles.map((tile) => <Tile key={tile.id} tile={tile} />)}
    </div>
  );
}
